import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    Col,
    Form,
    Input,
    Layout,
    Modal,
    message,
    Popconfirm,
    Row,
    Table,
    Tooltip,
    Select,
} from "antd";
import {
    PlusCircleFilled,
    EditOutlined,
    DeleteOutlined,
    CloseOutlined,
} from "@ant-design/icons";
import excel from "../assets/vector-icons/excel.png";
import search from "../assets/vector-icons/search.png";
import exchange from "../assets/vector-icons/exchange.png";
import moment from "moment";
import { exportExcel } from "../ExportExcel";
import "../../admin/Adminstyles.scss";
import ApiClient from "../../../src/helpers/ApiClient";
import AutoCompleteSelect from "../../common/AutoCompleteSelect/AutoCompleteSelect";

const { Content } = Layout;
const { Search, TextArea } = Input;

const DetailedQuery = () => {
    const [form] = Form.useForm();
    const [modalVisible, setModalVisible] = useState(false);
    const [DetailedQueryList, setDetailedQueryList] = useState([]);
    const [tableList, setTableList] = useState([]);
    const [showUpdateBtn, setShowUpdateBtn] = useState(false);
    const [currentId, setCurrentId] = useState(-1);
    const [showSearchBox, setShowSearchBox] = useState(false);
    const [QueryList, setQueryList] = useState([]);
    const { Option } = Select;
    useEffect(() => {
        getDetailedQueryList();
        getQueryList();
    }, []);

    const getQueryList = () => {
        ApiClient.get("query/getquery")
            .then((res) => {
                if (res.isSuccess) {
                    setQueryList(res.data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };


    const getDetailedQueryList = () => {
        ApiClient.get("query/getdetailedquery")
            .then((res) => {
                if (res.isSuccess) {
                    let data = res.data.map((item, index) => {
                        return {
                            SNo: index + 1,
                            ...item,
                            queryName: item?.query?.queryName ?? '',
                            queryId: item?.query?.id ?? 0,
                        };
                    });
                    setDetailedQueryList(data);
                    setTableList(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const add = (val) => {
        console.log(val)
        ApiClient.post("query/savedetailedquery", val)
            .then((response) => {
                return response;
            })
            .then((response) => {
                if (response.isSuccess) {
                    setModalVisible(false);
                    message.success("Successfully added DetailedQuery", 3);
                    getDetailedQueryList();
                    form.resetFields();
                } else if (!response.isSuccess) {
                    message.error("DetailedQuery Already existed", 3);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleModal = () => {
        if (showUpdateBtn) {
            setShowUpdateBtn(false);
            form.resetFields();
        }
        setModalVisible(true);
    };

    const deleteDetailedQuery = (Record) => {
        let Id = Record.id;
        ApiClient.delete("query/deletedetailedquery/" + Id)
            .then((res) => {
                if (res.isSuccess) {
                    message.success("DetailedQuery Deleted  successfully", 3);
                    getDetailedQueryList();
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const updateDetailedQuery = (val) => {
        ApiClient.put(`query/updatedetailedquery/${currentId.id}`, {}, val).then(
            (resp) => {
                if (resp.isSuccess) {
                    getDetailedQueryList();
                    setModalVisible(false);
                    message.success("DetailedQuery Updated successfully", 3);
                    setCurrentId(-1);
                }
            }
        );
    };

    const submitForm = (val) => {
        let obj = {
            queryId: val.queryId,
            detailedQueryName: val.detailedQueryName,
            detailedQueryDescription: val.detailedQueryDescription,
            status: true
        };
        if (showUpdateBtn) updateDetailedQuery(obj);
        else add(obj);
    };

    const tableActions = (currentRecord, Name) => {
        return (
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <div className="edit-icon" style={{ textAlign: "center" }}>
                    <EditOutlined
                        onClick={() => editCurrentItem(currentRecord, Name)}
                        style={{ color: "#1890ff", fontSize: "20px", textAlign: "center" }}
                    />
                </div>
                <div className="edit-icon" style={{ textAlign: "center" }}>
                    <Popconfirm
                        title="Are you sure want to delete?"
                        onConfirm={() => deleteDetailedQuery(Name)}
                    >
                        <DeleteOutlined
                            style={{ color: "red", fontSize: "20px", textAlign: "center" }}
                        />
                    </Popconfirm>
                </div>
            </div>
        );
    };

    const editCurrentItem = (id, Name) => {
        setShowUpdateBtn(true);
        setCurrentId(id);
        form.setFieldsValue({
            detailedQueryName: Name.detailedQueryName,
            detailedQueryDescription: Name.detailedQueryDescription,
            queryId: Name?.queryId ?? 0,
        });
        setModalVisible(true);
    };

    let lastIndex = 0;
    const uniqueKey = () => {
        return lastIndex++;
    };

    const searchData = () => {
        setShowSearchBox(true);
    };

    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "SNo",
            sorter: (a, b) => a.SNo - b.SNo,
        },

        {
            title: "queryName",
            dataIndex: "queryName",
            ellipsis: true,
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: "DetailedQuery Name",
            dataIndex: "detailedQueryName",
            ellipsis: true,
            sorter: (a, b) => a.name.localeCompare(b.name),
        },

        {
            title: "DetailedQuery Description",
            dataIndex: "detailedQueryDescription",
            ellipsis: true,
            // render: (text) => {
            //     return (
            //       <div
            //         dangerouslySetInnerHTML={{ __html: text }}
            //         style={{ maxHeight: "22px" }}
            //         className="table-ellipsis"
            //       ></div>
            //     );
            //   },
            sorter: (a, b) => a.name.localeCompare(b.name),

        },

        {
            title: "Actions",
            render: (id, name) => tableActions(id, name),
        },
    ];

    const searchTableData = (e) => {
        var searchVal = e.target.value;
        if (searchVal.length > 0) {
            const searchResults = tableList.filter(function (item) {
                if (item != undefined) {
                    return JSON.stringify(item)
                        .toLowerCase()
                        .includes(searchVal.toLowerCase());
                }
            });
            setTableList(searchResults);
        } else {
            setTableList(DetailedQueryList);
        }
    };

    const closeSearch = () => {
        setShowSearchBox(false);
        setTableList(DetailedQueryList);
    };

    const closeSearchInput = <CloseOutlined onClick={closeSearch} />;

    const handleExcel = () => {
        let excelData = tableList;
        excelData = excelData.map((item, i) => ({
            SNo: i + 1,
            detailedQueryName: item.detailedQueryName,
            detailedQueryDescription: item.detailedQueryDescription,
        }));

        exportExcel(excelData, "DetailedQuery");
    };
    const getDataByName = (val) => {
        let obj = {
            filter: {
                name: val,
                isActive: true,
            },
            page: 0,
        };
        ApiClient.post("codes/getcategories/list", obj)
            .then((response) => {
                return response;
            })
            .then((response) => {
                if (response.isSuccess) {
                    let data = response.results.map((item, index) => {
                        return {
                            SNo: index + 1,
                            ...item,
                        };
                    });

                    setDetailedQueryList(data);
                    setTableList(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <Layout>
            <div className="manage-markup-section">
                <Content className="container-fluid">
                    <div className="card-bt-gap">
                        <Card bordered={false}>
                            <Row className="card-add-heading">
                                <Col md={14} xs={12}>
                                    <div className="rows-count">
                                        <h5>View DetailedQuery</h5>
                                        <p>{tableList.length} rows found !</p>
                                    </div>
                                </Col>
                                <Col md={10} xs={12}>
                                    <Row>
                                        <Col md={14} xs={24}>
                                            <Form name="search">
                                                <AutoCompleteSelect
                                                    formItemProps={{
                                                        label: "",
                                                        name: "Search",
                                                        rules: [{ required: true, message: "Required!" }],
                                                    }}
                                                    selectProps={{
                                                        placeholder: "Search DetailedQuery Name",
                                                        onSelect: (val) => getDataByName(val),
                                                    }}
                                                    api={"codes/getDetailedQueryautosuggestion/"}
                                                    keytext="name"
                                                    keyvalue="name"
                                                />
                                            </Form>
                                        </Col>
                                        <Col md={10} xs={24}>
                                            <div className="action-images">
                                                &nbsp;&nbsp;
                                                {/* <img src={search} alt="search" onClick={() => searchData()} /> */}
                                                <img
                                                    src={excel}
                                                    alt="excel"
                                                    onClick={() => handleExcel()}
                                                />
                                                <img
                                                    src={exchange}
                                                    alt="exchange"
                                                    onClick={() => {
                                                        setTableList([]);
                                                        getDetailedQueryList();
                                                    }}
                                                />
                                                <PlusCircleFilled
                                                    className="add-deposit-icon"
                                                    onClick={handleModal}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                {tableList.length > 0 ? (
                                    <div>
                                        <Table
                                            // scroll={{ x: true }}
                                            className="table-scroll-none"
                                            bordered
                                            rowKey={uniqueKey}
                                            dataSource={tableList}
                                            columns={columns}
                                            pagination={{
                                                defaultPageSize: 25,
                                                showSizeChanger: true,
                                                pageSizeOptions: ["25", "50", "100", "125"],
                                            }}
                                        />
                                    </div>
                                ) : (
                                    "No Record Found"
                                )}
                            </Row>
                        </Card>
                    </div>
                </Content>
            </div>
            <Modal
                title={[
                    <div>
                        <h6 style={{ marginBottom: "0px" }}>
                            <strong>
                                {showUpdateBtn ? "Update DetailedQuery" : "Add DetailedQuery"}
                            </strong>
                        </h6>
                    </div>,
                ]}
                className="promo-modal-header"
                visible={modalVisible}
                onOk={(e) => setModalVisible(false)}
                onCancel={(e) => setModalVisible(false)}
                footer={[
                    <Button key="add" type="primary" onClick={form.submit}>
                        {showUpdateBtn ? "Update" : "Add"}
                    </Button>,
                ]}
            >
                <Form layout="vertical" form={form} onFinish={submitForm}>
                    <Row>
                        <Col span={24}>
                            <Form.Item label="Query" rules={[{ required: true }]} name="queryId">
                                <Select showSearch placeholder="Select Category" filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {QueryList.map((item, index) => (
                                        <Option key={index} value={item.id}>
                                            {`${item.queryName}`}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="DetailedQuery"
                                name="detailedQueryName"
                                rules={[{ required: true, message: "Please enter DetailedQuery" }]}
                            >
                                <Input autocomplete="newpassword" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="detailedQueryDescription" label="DetailedQuery Description" rules={[{ required: false }]}>
                                <TextArea />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </Layout>
    );
};
export default DetailedQuery;
